import { CSSProperties } from "@mui/styled-engine";

export const ABSOLUTEFILL: CSSProperties = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
};
